
const subscribers = new Set();
let lastIntent = null;

export function requestNavigation(intent) {
  if (!intent || typeof intent !== "object") return;
  lastIntent = intent;
  for (const cb of subscribers) {
    try {
      cb(intent);
    } catch (err) {
      // A broken subscriber must not stop the others (or the tool that
      // fired this) — log and move on.
      // eslint-disable-next-line no-console
      console.warn("[navigation] subscriber threw:", err);
    }
  }
}

export function subscribeNavigation(cb) {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}

export function getLastNavigation() {
  return lastIntent;
}

export function resetNavigationIdentityState() {
  lastIntent = null;
}
